import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER } = DataType

export default {
	toJSON() {
		return {
			id: 26,
			label: 'one',
			scoringTypeId: 2,
			type: 'metric',
			dataType: NUMBER,
			projectId: 1,
			organizationId: 1,
			originallyDocked: false,
			useSourceName: false,
			useSourceNotes: false,
			useSourceOwners: false,
			useSourceTags: false,
			useSourceRelatedItems: false,
			dereferenced: false,
			calendarId: 1,
			percentWeighting: 0.25,
			percentWeightingIgnoringPerformance: 0.25,
			aggregationType: 'sum',
			series: [
				{
					label: 'Actual',
					updateType: 'manual',
					key: 'scorecards.node.metric.actualValue.short'
				},
				{
					label: 'Red',
					updateType: 'manual',
					key: 'scorecards.node.metric.threshold.base.short'
				},
				{
					label: 'Goal',
					updateType: 'manual',
					key: 'scorecards.node.metric.threshold.goal.short'
				}
			],
			status: 'weighted',
			scores: [
				{
					scorecardItemId: 26,
					periodId: 3,
					applicable: true,
					actual: 3245345,
					score: 10,
					color: 'green',
					thresholds: [
						0,
						1000000
					],
					dataType: NUMBER,
					periodLabel: 'January 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 4,
					applicable: true,
					color: 'gray',
					thresholds: [
						0,
						1000000
					],
					periodLabel: 'February 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 5,
					applicable: true,
					actual: 45234,
					score: 3.4841133333333336,
					color: 'yellow',
					thresholds: [
						0,
						1000000
					],
					dataType: NUMBER,
					periodLabel: 'March 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 6,
					applicable: true,
					actual: 324534,
					score: 4.415113333333333,
					color: 'yellow',
					thresholds: [
						0,
						1000000
					],
					dataType: NUMBER,
					periodLabel: 'April 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 7,
					applicable: false,
					color: 'slate',
					thresholds: [
						null,
						null
					],
					periodLabel: 'May 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 8,
					applicable: true,
					actual: 253452345,
					score: 10,
					color: 'green',
					thresholds: [
						0,
						1000000
					],
					dataType: NUMBER,
					periodLabel: 'June 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 9,
					applicable: true,
					actual: 24532,
					score: 3.415106666666667,
					color: 'yellow',
					thresholds: [
						0,
						1000000
					],
					dataType: NUMBER,
					periodLabel: 'July 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 10,
					applicable: true,
					color: 'gray',
					thresholds: [
						0,
						1000000
					],
					periodLabel: 'August 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 11,
					applicable: true,
					actual: 2345,
					score: 3.34115,
					color: 'yellow',
					thresholds: [
						0,
						1000000
					],
					dataType: NUMBER,
					periodLabel: 'September 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 12,
					applicable: true,
					actual: 2345,
					score: 3.34115,
					color: 'yellow',
					thresholds: [
						0,
						1000000
					],
					dataType: NUMBER,
					periodLabel: 'October 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 13,
					applicable: true,
					actual: 2345,
					score: 3.34115,
					color: 'yellow',
					thresholds: [
						0,
						1000000
					],
					dataType: NUMBER,
					periodLabel: 'November 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 14,
					applicable: true,
					actual: 2345,
					score: 3.34115,
					color: 'yellow',
					thresholds: [
						0,
						1000000
					],
					dataType: NUMBER,
					periodLabel: 'December 2020'
				},
				{
					scorecardItemId: 26,
					periodId: 24,
					applicable: true,
					actual: 257101370,
					score: 10,
					color: 'green',
					thresholds: [
						0,
						9000000
					],
					dataType: NUMBER
				}
			],
			relatedItems: [
				{
					id: 2,
					relatedId: 1008,
					type: 'file',
					subtype: 'file',
					label: 'docs-compressed',
					organization: {
						id: 1,
						label: 'My Organization'
					}
				}
			],
			scoreInPeriodId: 24,
			chart: {
				type: 'single-time-series',
				startPeriodDelta: -12,
				endPeriodDelta: 0,
				xAxisLabels: true,
				yAxisLabels: true,
				series: [
					{
						sortOrder: 0,
						properties: {
							dataField: '-1',
							plotType: 'line',
							color: 'default',
							axisPosition: 'left',
							labelType: 'domain-object-label',
							domainObjectId: 26,
							section: 'scorecards'
						}
					}
				]
			},
			chartData: {
				scorecards: [
					{
						id: 26,
						label: 'one',
						description: '',
						scoringTypeId: 2,
						dataType: NUMBER,
						calendarId: 1,
						aggregationType: 'sum',
						type: 'metric',
						useSourceNotes: false,
						organizationId: 1,
						scores: {
							24: {
								scorecardItemId: 26,
								periodId: 24,
								applicable: true,
								actual: 257101370,
								score: 10,
								color: 'green',
								thresholds: [
									0,
									9000000
								],
								dataType: NUMBER
							}
						}
					}
				],
				organizations: [
					{
						id: 1,
						label: 'My Organization',
						view: true
					}
				],
				initiatives: [],
				datasets: [],
				datasetSeriesValues: [],
				aggregatedSeriesValues: []
			},
			descendantLowestScore: null,
			updateActual: true,
			updateThresholds: true,
			createPeriodNotes: true,
			createGlobalNotes: true,
			rootId: 1,
			actualAndThresholdValuePeriodIds: [
				3,
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12,
				13,
				14
			],
			yesNo: false
		}
	},
	get: arg => {
		if (arg == 'actualAndThresholdValuePeriodIds') {
			return [
				3,
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12,
				13,
				14
			]
		}

		if (arg == 'dataType') {
			return NUMBER
		}
	},
	score: () => {
		return {
			scorecardItemId: 26,
			periodId: 3,
			applicable: true,
			actual: 3245345,
			score: 10,
			color: 'green',
			thresholds: [
				0,
				1000000
			],
			dataType: NUMBER,
			periodLabel: 'January 2020'
		}
	}
}
